import React, { useState, useEffect, useCallback } from "react";
import Header from "../../components/header/header";
import Pagination from "react-bootstrap/Pagination";
import { Link } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { Row, Col, Form } from "react-bootstrap";
import "./Unidades_medida_listage.css";
import { useNavigate, useParams } from "react-router-dom";
import CustomModal from "../../components/modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faPencil, faTrashCan, faSearch, faFilter} from "@fortawesome/free-solid-svg-icons";
import { getUnidadeMedida } from "../../services/api_unidade_medida";
import Swal from "sweetalert2";
import { deleteUnidadeMedida } from "../../services/api_cadastro_unidade_medida";

import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { blue } from "@mui/material/colors";
import { Permissions } from "../../hooks/Permission/permission";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: blue[600],
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const UnidadeMedidaListage = () => {
  const navigate = useNavigate();
  const itemsPerPageOptions = [5, 10, 20, 50];
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [dados, setDados] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const POLLING_INTERVAL = 30000;

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body, isQuestion, qFunc) => {
    setModalContent({ title, body, isQuestion, qFunc });
    setShowModal(true);
  };

  const fetchData = useCallback(async () => {
    try {
      const response = await getUnidadeMedida();
      setDados(response.data.UnidadesMedida); // Corrigido: Setar dados com response.data.empresas
      setLoading(false);
    } catch (error) {
      console.error("Erro ao obter dados:", error);
    }
  }, [])

  useEffect(() => {
    fetchData();
    const interval = setInterval(() => {
      fetchData();
    }, POLLING_INTERVAL);
  
    return () => clearInterval(interval);
  }, [fetchData]);

  useEffect(() => {
    const filterData = () => {
      if (dados && dados.length > 0) {
        const filtered = dados.filter(
          (item) =>
            (item.descricao && item.descricao.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (item.id && item.id.toString().includes(searchTerm))
        );

        setFilteredData(filtered);
        setCurrentPage(1);
      } else {
        // Caso os dados estejam vazios ou undefined, limpar os dados filtrados
        setFilteredData([]);
        setCurrentPage(1);
      }
    };

    filterData();
  }, [searchTerm, dados]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = searchTerm
    ? filteredData
      ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
      : []
    : dados
    ? dados.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = Math.ceil(
    (searchTerm
      ? filteredData
        ? filteredData.length
        : 0
      : dados
      ? dados.length
      : 0) / itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };

  const handleGoToEdit = (id) => {
    navigate(`/unidade-medida-cadastrar`, { state: { id } });
  };

  const handleDeleteModal = (id) => {
    Swal.fire({
      title: "Tem certeza de que deseja inativar o registro?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#808B96",
      confirmButtonText: "Inativar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const response = await deleteUnidadeMedida(id);
          //console.log(response);
          if (response && response.data) {
            //console.log(response);
            // Corrigido: Verificar se há response e response.data
            const updatedData = dados.filter((item) => item.id !== id);
            setDados(updatedData);
            setShowModal(false);
            setLoading(false);
            return true;
          } else if (response.response.status === 422) {
            if (response.response.data.mensagem) {
              const mensagem = response.response.data.mensagem;
              return Swal.showValidationMessage(`${mensagem}`);
            } else if (response.response.data.errors) {
              const error = response.response.data.errors;
              return Swal.showValidationMessage(`Erro: ${error}`);
            }
          }
        } catch (error) {
          return Swal.showValidationMessage(`
          Erro: ${error}
        `);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value) {
          Swal.fire({
            title: "Inativado!",
            text: "O registro foi inativado com sucesso.",
            icon: "success",
            timer: 2500,
          });
        }
      }
    });
  };

  const renderPaginationItems = () => {
    const paginationItems = [];

    paginationItems.push(
      <Pagination.Prev
        key="prev"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
    );

    paginationItems.push(
      <Pagination.Item
        key={1}
        active={1 === currentPage}
        onClick={() => handlePageChange(1)}
      >
        {1}
      </Pagination.Item>
    );

    if (currentPage > 3) {
      paginationItems.push(
        <Pagination.Ellipsis key="ellipsis-start" disabled />
      );
    }

    for (
      let i = Math.max(2, currentPage - 2);
      i <= Math.min(totalPages - 1, currentPage + 2);
      i++
    ) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (currentPage < totalPages - 2) {
      paginationItems.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
    }

    if (totalPages > 1) {
      paginationItems.push(
        <Pagination.Item
          key={totalPages}
          active={totalPages === currentPage}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    paginationItems.push(
      <Pagination.Next
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    );

    return paginationItems;
  };

  function ExpansibleRow(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow
          className="table-row"
          sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell />
          <TableCell component="th" scope="row">
            {row.id}
          </TableCell>
          <TableCell component="th" scope="row">
            {row.descricao}
          </TableCell>
          <TableCell style={{justifyContent: 'flex-end', borderBottom: "none"}} align="left" className="d-flex">
            <Permissions
            requiredPermissions={[
              {entidade: "UnidadeMedida", actions: ['update']}
            ]}
            >
              <button
                className="btn btn-white text-dark"
                onClick={() => handleGoToEdit(row.id)}
                disabled={row.deleted_at !== null}
              >
                <Link>
                  <FontAwesomeIcon icon={faPencil} size="1x" color={row.deleted_at !== null ? "gray" : "#1E90FF"} />
                </Link>
              </button>
            </Permissions>
            <Permissions
            requiredPermissions={[
              {entidade: "UnidadeMedida", actions: ['delete']}
            ]}
            >
              <button
                className="btn btn-white text-dark"
                onClick={() => handleDeleteModal(row.id)}
                disabled={row.deleted_at !== null}
              >
                <FontAwesomeIcon icon={faTrashCan} size="1x" color={row.deleted_at !== null ? "gray" : "#F08080"} />
              </button>   
            </Permissions>

            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <p>
                  <strong>ID :</strong> {row.id}
                </p>
                <p>
                  <strong>Descrição: </strong> {row.descricao}
                </p>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <>
      <Header title="Cadastros / Listagem de unidades de medida" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        <div className="mb-3">
          <div className="mt-1 mb-3 mt-3">
            <Permissions
            requiredPermissions={[
              {entidade: "UnidadeMedida", actions: ['store']}
            ]}
            >
              <Link to={`/unidade-medida-cadastrar`}>
                <button className="btn btn-light text-dark">
                  <FontAwesomeIcon icon={faPlus} size="1x" color="#006400" />
                </button>
              </Link>
            </Permissions>
          </div>

          {isLoading ? (
            <></>
          ) : (
            <>
              <Row>
                <Col md={2} className="mb-3">
                  <Form.Group className="d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={faFilter}
                      size="1x"
                      color="#000000"
                      className="mr-2"
                    />

                    <Form.Control
                      as="select"
                      value={itemsPerPage}
                      onChange={handleItemsPerPageChange}
                      className="ml-2"
                    >
                      {itemsPerPageOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={3} className="mb-3 ml-auto">
                  <Form.Group className="d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={faSearch}
                      size="1x"
                      color="#000000"
                      className="mr-2"
                    />

                    <Form.Control
                      type="text"
                      placeholder="Digite para pesquisar"
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="ml-2"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </div>

        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell />
                    <StyledTableCell>ID</StyledTableCell>
                    <StyledTableCell>Descrição</StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentItems.map((item) => (
                    <ExpansibleRow key={item.id} row={item} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Pagination className="mt-4">{renderPaginationItems()}</Pagination>
          </>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
        isQuestion={modalContent.isQuestion}
        questionAction={modalContent.qFunc}
      />
    </>
  );
};

export default UnidadeMedidaListage;
